import React from 'react'
import {useIntl} from 'react-intl'

import {Text} from '@vio/atlas/Text'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'
import {GuestSplitText} from '@vio/shared/src/search/GuestPicker/GuestSplitText'

type Props = {
  checkIn: string
  checkOut: string
  numberOfRooms: number
  numberOfAdults: number
  numberOfChildren: number
}

/**
 * Dates, room count and adults/children split, e.g. "Dec 17 - Dec 18 · 2 rooms · 4 adults, 1 child".
 */
export const RoomsSectionSearchContextSubtitle = ({
  checkIn,
  checkOut,
  numberOfRooms,
  numberOfAdults,
  numberOfChildren
}: Props) => {
  const {formatDate} = useIntl()
  const dateOptions = {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC'
  } as const

  return (
    <Text variant="labelS" colorPath="content.neutral.secondary">
      <FormattedMessageWrapper
        id="roomsList.searchContextSubtitle"
        defaultMessage="{checkIn} – {checkOut} · {count, plural, one {# room} other {# rooms}} · {guestSplit}"
        values={{
          checkIn: formatDate(checkIn, dateOptions),
          checkOut: formatDate(checkOut, dateOptions),
          count: numberOfRooms,
          guestSplit: (
            <GuestSplitText
              numberOfAdults={numberOfAdults}
              numberOfChildren={numberOfChildren}
            />
          )
        }}
      />
    </Text>
  )
}
